// Tiny event emitter shared by the native event emitter shims.
const listeners = {};

const emitter = {
  addListener(event, handler) {
    (listeners[event] = listeners[event] || []).push(handler);
    return {
      remove() {
        emitter.removeListener(event, handler);
      },
    };
  },
  removeListener(event, handler) {
    listeners[event] = (listeners[event] || []).filter(h => h !== handler);
  },
  removeAllListeners(event) {
    if (event) {
      delete listeners[event];
    }
  },
  emit(event, payload) {
    (listeners[event] || []).slice().forEach(handler => handler(payload));
  },
};

export default emitter;
